<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="page-title">
                    <h5>{{ 'shipping_options.title' | translate }}</h5>
                </div>

                <div *ngIf="loading" class="text-center py-5">
                    {{ 'common.loading' | translate }} ...
                </div>

                <div *ngIf="!loading" class="shipping-options-card">
                    <div class="mb-4" *ngIf="!showForm">
                        <button class="btn btn-primary btn-add-option" (click)="toggleForm()">
                            {{ 'shipping_options.add_new' | translate }}
                        </button>
                    </div>

                    <div class="card" *ngIf="showForm">
                        <div class="card-header">
                            <h5 *ngIf="!isEditing">{{ 'shipping_options.add_new' | translate }}</h5>
                            <h5 *ngIf="isEditing">{{ 'shipping_options.edit' | translate }}</h5>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="shippingForm" (ngSubmit)="onSubmit()">
                                <div class="mb-3">
                                    <label for="shippingTypeId" class="form-label">
                                        {{ 'shipping_options.select_shipping_type' | translate }}
                                    </label>
                                    <select id="shippingTypeId" class="form-control" formControlName="shippingTypeId"
                                        [ngClass]="{ 'is-invalid': shippingForm.get('shippingTypeId')?.invalid && shippingForm.get('shippingTypeId')?.touched }">
                                        <option value="">{{ 'common.select' | translate }}</option>
                                        <option *ngFor="let type of shippingTypes" [value]="type.id">
                                            {{ type.description }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback"
                                        *ngIf="shippingForm.get('shippingTypeId')?.invalid && shippingForm.get('shippingTypeId')?.touched">
                                        {{ 'shipping_options.shipping_type_required' | translate }}
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="countryId" class="form-label">
                                        {{ 'shipping_options.select_country' | translate }}
                                    </label>
                                    <select id="countryId" class="form-control" formControlName="countryId"
                                        [ngClass]="{ 'is-invalid': shippingForm.get('countryId')?.invalid && shippingForm.get('countryId')?.touched }">
                                        <option value="">{{ 'common.select' | translate }}</option>
                                        <option *ngFor="let country of countries" [value]="country.id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback"
                                        *ngIf="shippingForm.get('countryId')?.invalid && shippingForm.get('countryId')?.touched">
                                        {{ 'shipping_options.country_required' | translate }}
                                    </div>
                                </div>

                                <div class="d-flex gap-2">
                                    <button type="submit" class="btn btn-success"
                                        [disabled]="shippingForm.invalid || submitting">
                                        <span *ngIf="!submitting && !isEditing">{{ 'shipping_options.submit' | translate
                                            }}</span>
                                        <span *ngIf="!submitting && isEditing">{{ 'shipping_options.update' | translate
                                            }}</span>
                                        <span *ngIf="submitting">{{ 'common.loading' | translate }} ...</span>
                                    </button>
                                    <button type="button" class="btn btn-secondary" (click)="toggleForm()">
                                        {{ 'common.cancel' | translate }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="card mt-4" *ngIf="!showForm">
                        <div class="card-header">
                            <h5>{{ 'shipping_options.your_options' | translate }}</h5>
                        </div>
                        <div class="card-body">
                            <div *ngIf="shippingOptions.length === 0" class="empty-state">
                                <p class="text-muted">{{ 'shipping_options.no_options' | translate }}</p>
                            </div>
                            <div *ngIf="shippingOptions.length > 0" class="table-responsive">
                                <table class="table table-striped shipping-options-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 35%;">{{ 'shipping_options.select_shipping_type' |
                                                translate }}</th>
                                            <th style="width: 45%;">{{ 'shipping_options.select_country' | translate }}
                                            </th>
                                            <th style="width: 20%;">{{ 'shipping_options.actions' | translate }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let option of shippingOptions">
                                            <td>{{ option.shippingType?.description || option.shippingType }}</td>
                                            <td>{{ option.country?.name || option.country }}</td>
                                            <td>
                                                <a [routerLink]="['/user/shipping-means', option.id]" class="me-3"
                                                    title="{{ 'common.view' | translate }}">
                                                    <i class="fa fa-eye fa-view-link"></i>
                                                </a>
                                                <button class="me-3 btn-action" (click)="editOption(option)"
                                                    title="{{ 'common.edit' | translate }}">
                                                    <i class="fa fa-edit fa-edit-link"></i>
                                                </button>
                                                <button (click)="confirmDelete(option)" class="btn-action"
                                                    title="{{ 'common.delete' | translate }}">
                                                    <i class="fa fa-trash fa-delete-link"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-sidebar [currentUser]="user"></app-sidebar>
            </div>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal" tabindex="-1" role="dialog" [ngClass]="{ 'd-block': showDeleteModal }" *ngIf="showDeleteModal">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'shipping_options.delete_confirm_title' | translate }}</h5>
                <button type="button" class="btn-close" (click)="closeDeleteModal()"></button>
            </div>
            <div class="modal-body">
                <p>{{ 'shipping_options.delete_confirm_message' | translate }}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeDeleteModal()">
                    {{ 'common.cancel' | translate }}
                </button>
                <button type="button" class="btn btn-danger" (click)="deleteOption()">
                    {{ 'common.delete' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showDeleteModal"></div>